
class CalendarPickupScheduler {
  constructor({ input, pickupLocations, hasRestrictedItem, christmasDate, calendarOptions, maxDate, onChange }) {
    this.locations = pickupLocations;
    this.hasRestrictedItem = hasRestrictedItem;
    this.christmasDate = christmasDate;

    this.picker = flatpickr(input, {
      ...calendarOptions,
      maxDate,
      onChange: (selectedDates, dateStr) => onChange(selectedDates, dateStr),
    });
  }

  getLocationByHandle(handle) {
    return this.locations[handle] || null;
  }

  getAllowedDays(location) {
    return CalendarUtils.DAYS.filter(
      (day) => location && location[day] && location[day] !== "",
    ).map((day) => CalendarUtils.DAY_NUMBER[day]);
  }

  getBlockedDates(location) {
    const dates = [];
    const specialDates = (location.specialHours || []).map((entry) => entry.date);

    (location.blockedDates || []).forEach((entry) => {
      if (!entry.start) return;

      if (entry.start === entry.end || !entry.end) {
        if (!specialDates.includes(entry.start)) dates.push(entry.start);
        return;
      }

      let current = new Date(`${entry.start}T00:00:00`);
      const end = new Date(`${entry.end}T00:00:00`);

      while (current <= end) {
        const dateStr = CalendarUtils.formatYmd(current);
        if (!specialDates.includes(dateStr)) dates.push(dateStr);
        current.setDate(current.getDate() + 1);
      }
    });

    return dates;
  }

  getHoursForDate(location, date) {
    const dayKey = CalendarUtils.DAYS[date.getDay()];
    const dateKey = CalendarUtils.formatYmd(date);
    const specialHours = location.specialHours || [];
    const specialEntry = specialHours.find((entry) => entry.date === dateKey);

    if (specialEntry) {
      return { open: specialEntry.open, close: specialEntry.close, isSpecial: true };
    }

    const hours = location[dayKey];
    if (!hours) return null;

    const formatted = hours
      .split(",")
      .map((slot) => slot.replace("-", " – "))
      .join(" & ");

    return { formatted, isSpecial: false };
  }

  applyLocationRules(location) {
    const allowedDays = this.getAllowedDays(location);
    const specialDates = (location.specialHours || []).map((entry) => entry.date);
    const blockedDates = this.getBlockedDates(location);

    this.picker.set("disable", [
      (date) => {
        const dateStr = CalendarUtils.formatYmd(date);

        if (specialDates.includes(dateStr)) return false;

        const isBlocked = blockedDates.some((blocked) => {
          if (typeof blocked === "string") return blocked === dateStr;
          if (blocked.from && blocked.to) {
            return dateStr >= blocked.from && dateStr <= blocked.to;
          }
          return false;
        });

        if (isBlocked) return true;
        if (!allowedDays.includes(date.getDay())) return true;

        const day = date.getDay();
        const daysToLastTuesday = ((day + 5) % 7) + 1;
        const cutoff = new Date(date);
        cutoff.setDate(date.getDate() - daysToLastTuesday);
        cutoff.setHours(23, 59, 59, 0);
        return new Date() > cutoff;
      },
    ]);

    this.picker.clear();
    this.picker.redraw();
  }

  clear() {
    this.picker.clear();
  }

  setMinMax(minDate, maxDate) {
    this.picker.set("minDate", minDate);
    this.picker.set("maxDate", maxDate);
  }

  jumpToToday() {
    this.picker.jumpToDate(new Date());
    this.picker.redraw();
  }
}
